<template>
    <div>
        <div class="spark-screen container">
            <div class="row">
                <div class="col-md-2 spark-settings-tabs">
                    <aside>
                        <ul class="nav flex-column mb-4">
                            <li class="nav-item">
                                <a class="nav-link active" href="#newContact" aria-controls="newContact" role="tab" data-toggle="tab">New Contact</a>
                            </li>
                        </ul>
                    </aside>
                </div>
                <div class=" col-md-10 tab-content">
                    <div class="col-md-12 active tab-pane" role="tabcard" id="newContact">
                        <contact-required-fields-form></contact-required-fields-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContactRequiredFieldsForm from "../contact/contact-required-fields-form.vue";

export default {
    name: 'contact-required-fields',
    components: {ContactRequiredFieldsForm}
}
</script>
